module.exports = "/build/web/svg/mvo.15fb8c8e3dd7f0a2d9d64d996fee756f.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/mvo.svg
// module id = 174
// module chunks = 24